module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/hr/recruiting-map/recruiting-map/recruiting-map.component.css
// module id = ./src/app/web/game/management/business-units/hr/recruiting-map/recruiting-map/recruiting-map.component.css
// module chunks = main